import { Divider, List, ListItem, ListItemButton, Stack, Typography } from '@mui/joy';
import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useAuthActions } from 'auth/hooks';
import { IUserAutocomplete } from 'auth/types';
import { useFormContext } from 'core/states';
import { Color, Level, Size } from 'theme/enums';

import { ISwitchUserFormData } from './type';
import { getUserIdAndName } from './utils';

interface IProps {
  onSubmit: (
    reset: UseFormReset<ISwitchUserFormData>
  ) => (data: { user: IUserAutocomplete }) => void;
}

export const MostRecent = ({ onSubmit }: IProps) => {
  const { t } = useTranslation();

  const { reset, setValue } = useFormContext();

  const { mostRecentImpersonatedUsers } = useAuthActions();

  const onSelectUser = (user: IUserAutocomplete) => {
    setValue('user', user);

    onSubmit(reset)({ user });
  };

  return (
    <Stack spacing={0}>
      <Typography level={Level.TITLE_MD}>{t('labelMostRecent')}</Typography>

      <Divider />

      <List size={Size.MD} sx={{ gap: 1 }}>
        {mostRecentImpersonatedUsers.length <= 0 && (
          <Typography level={Level.BODY_XS}>{t('messageNoRecentImpersonatedUsers')}</Typography>
        )}

        {mostRecentImpersonatedUsers.map((user) => (
          <ListItem key={user.id}>
            <ListItemButton onClick={() => onSelectUser(user)}>
              <Stack spacing={0}>
                <Typography level={Level.TITLE_SM} color={Color.PRIMARY}>
                  {getUserIdAndName(user)}
                </Typography>

                <Typography level={Level.BODY_XS}>{user.email}</Typography>
              </Stack>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
};
